import { InsType } from 'constants/enums/insType.enum';
import { InsTypeNameEN } from 'constants/enums/insTypeNameEN.enum';

/**
 * @description 讓險種類別代碼對應險種類別英文名稱用
 */
const InsTypeDefinesEN: Readonly<Record<InsType, InsTypeNameEN>> = {
  [InsType.All]: InsTypeNameEN.All,
  [InsType.Travel]: InsTypeNameEN.Travel,
  [InsType.Car]: InsTypeNameEN.Car,
  [InsType.Moto]: InsTypeNameEN.Moto,
  [InsType.Fire]: InsTypeNameEN.Fire,
  [InsType.MobileDevice]: InsTypeNameEN.MobileDevice,
  [InsType.Pet]: InsTypeNameEN.Pet,
  [InsType.ECar]: InsTypeNameEN.Ecar,
  [InsType.Emoto]: InsTypeNameEN.Emoto
};

export default InsTypeDefinesEN;
